import { ComponentProps } from 'react';
import IconButton from '@alltrails/denali/components/IconButton';
import Calendar from '@alltrails/denali/icons/Calendar';
import { useExperiments } from '@alltrails/experiments';
import useCreateEventCta from '../../hooks/useCreateEventCta';
import type { EventMapType } from '../../types';

type CreateEventButtonProps = Pick<ComponentProps<typeof IconButton>, 'size' | 'variant'> & {
  mapId: number;
  mapType: EventMapType;
};

const CreateEventIconButton = ({ mapId, mapType, ...iconButtonProps }: CreateEventButtonProps) => {
  const { modals, onClick } = useCreateEventCta({ mapId, mapType });

  return (
    <>
      {/* TODO: EVENT TRANSLATIONS (DISCO-24049) */}
      <IconButton {...iconButtonProps} icon={{ Component: Calendar }} onClick={onClick} title="Create invite" />
      {modals}
    </>
  );
};

const CreateEventButtonWrapper = (props: CreateEventButtonProps) => {
  const experiments = useExperiments();

  if (experiments['web-disco-events']?.value === 'on') {
    return <CreateEventIconButton {...props} />;
  }

  return null;
};

export default CreateEventButtonWrapper;
